import { use, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchVehicle,
  fetchVehicleGroup,
  removeVehicle,
} from "../../store/slices/Vehicle/thunk";
import { Visibility, Edit, Delete } from "@mui/icons-material";
import { Pagination } from "@mui/material";
import { FaEye } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";

import "./Vehicle.scss";
import DRIVE from "../../assets/71dfd03e2bc3d97ab6e9d15c83ddcf00.jpg";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
  Input,
  InputAdornment,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/deleteModal";
import ButtonExample from "../../components/responseLoader";
import Loader from "../../components/loader";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";
const VehicleList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllVehicle, setAllVehicle] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;
  const [getCurrentUser, setCurrentUser] = useState<any>(null);
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllVehicle);
  const gotoEdit = (id: string) => {
    navigate(`/edit-vehicle/${id}`);
  };
  const gotodetail = (id: string) => {
    navigate(`/view-vehicle/${id}`);
  };
  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true);

      try {
        const response = await dispatch(
          fetchVehicle(page, ITEMS_PER_PAGE, search)
        );

        if (response && response.data.data.length > 0 && response.isSuccess) {
          setAllVehicle(response.data.data);
          setTotalCount(response.data.totalCount);
        } else {
          setAllVehicle([]);
          setTotalCount(0);
        }
      } catch (error) {
        console.error("Vehicle fetch error:", error);
        setAllVehicle([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false);
      }
    }, DEBOUNCE_DELAY);

    
    return () => {
      clearTimeout(handler);
    };
  }, [search, page, dispatch]);

  useEffect(() => {
    const fetchUser = async () => {
        const userData = localStorage.getItem("user");
      if (userData) {
        setCurrentUser(JSON.parse(userData));
      }
    };
    fetchUser();
  }, []);
  const deleteVehicle = async (id: string) => {
    const response = await dispatch(removeVehicle(id));
    if (response.isSuccess) {
      const newVehicle = getAllVehicle.filter((item: any) => item._id !== id);
      setAllVehicle(newVehicle);
    }
  };

  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await deleteVehicle(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
  const navigateToAddvehicle = () => {
    navigate("/add-vehicle");
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className="Management align-items-baseline" style={{ flexShrink: 0 }}>
        <div className="d-flex flex-column">
          <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
            Vehicle's Management
          </h2>
          <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
            Maintain and track your fleet
          </p>
        </div>

        <p>
           {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (
            <button
              className="px-2 py-2"
              onClick={navigateToAddvehicle}
              style={{
                background: "#2563EB",
                color: "#fff",
                borderRadius: "10px",
                height: "40px",
                width: "170px",
                border: "none",
                boxShadow: "none",
              }}
            >
              <AddIcon />
              Add New Vehicle
            </button>
          )}
        </p>
      </div>

      <div style={{ marginBottom: "16px", padding: "0px 16px 0px 0px" }}>
        <TextField
          variant="outlined"
          placeholder="Search vehicle by name or registration number..."
          size="small"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          sx={{
            minWidth: 380,
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              backgroundColor: "#fff",
              height: "40px",
              "& fieldset": { borderColor: "#d0d5dd" },
              "&:hover fieldset": { borderColor: "#7c6dff" },
              "&.Mui-focused fieldset": { borderColor: "#7c6dff" },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <IoSearchOutline style={{ color: "#98a2b3", fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <Paper sx={{ padding: 2, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <TableContainer sx={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
          <Table
            className="MuiTable-root table tabless css-1xwxv7r-MuiTable-root"
            sx={{ tableLayout: "auto", width: "100%" }}
          >
            <TableHead className="th">
              <TableRow className="table-h-row">
                <TableCell className="table-cell" style={{ color: "#6b7280", background: "#f9fafb", fontWeight: "900", fontSize: "18px" }}>S.No</TableCell>
                <TableCell className="table-cell" style={{ color: "#6b7280", background: "#f9fafb", fontWeight: "500", fontSize: "18px" }}>VEHICLE<FilterPopover column="vehicleName" filterType="text" currentValue={filters.vehicleName || ""} onFilterChange={setFilter} onClear={clearFilter} /></TableCell>
                <TableCell className="table-cell" style={{ color: "#6b7280", background: "#f9fafb", fontWeight: "500", fontSize: "18px" }}>Registration No.<FilterPopover column="registrationNumber" filterType="text" currentValue={filters.registrationNumber || ""} onFilterChange={setFilter} onClear={clearFilter} /></TableCell>
                <TableCell className="table-cell" style={{ color: "#6b7280", background: "#f9fafb", fontWeight: "500", fontSize: "18px" }}>STATUS<FilterPopover column="status" filterType="text" currentValue={filters.status || ""} onFilterChange={setFilter} onClear={clearFilter} /></TableCell>
                <TableCell className="table-cell" style={{ color: "#6b7280", background: "#f9fafb", fontWeight: "500", fontSize: "18px" }}>ACTIONS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tb">
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Loader />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {filteredData.map((item: any, index) => (
                  <TableRow className="t-row" key={index}>
                    <TableCell className="" style={{ fontWeight: "200", width: "60px" }}>
                      {(page - 1) * ITEMS_PER_PAGE + index + 1}
                    </TableCell>
                    <TableCell
                      className="table-cell"
                      sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
                    >
                      <div className="d-flex gap-1 align-items-baseline">
                        <div
                          style={{
                            width: "80px",
                            height: "50px",
                            flexShrink: 0,
                          }}
                        >
                          <img
                            src={item.vehicleImage || "--"}
                            className="img-fluid"
                            style={{
                              borderRadius: "8px",
                              objectFit: "contain",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </div>
                        <p style={{ margin: 0 }}>{item.vehicleName || "--"}</p>
                      </div>
                    </TableCell>

                    {/*  <TableCell className="table-cell">
                    {item.registrationNumber || '--'}
                  </TableCell> */}
                    {/* <TableCell className="table-cell">{item.model || '--'}</TableCell>
                  <TableCell className="table-cell">{item.chassisNo|| '--'}</TableCell> */}
                    <TableCell
                      className="table-cell"
                      style={{ fontWeight: "200" }}
                    >
                      {item.registrationNumber || "--"}
                    </TableCell>
                    <TableCell className="table-cell">
                      <Chip
                        label={item.status || "--"}
                        style={{
                          backgroundColor: "#DCFCE7",
                          color: "#166534",
                          fontSize: ".75rem",
                          borderRadius: "15px",
                        }}
                        sx={{
                          backgroundColor: "#DCFCE7", // Tailwind's green-100
                          color: "#166534",
                          fontSize: ".75rem",
                          borderRadius: "15px",
                          "& .MuiChip-label": {
                            overflow: "visible",
                            textOverflow: "unset",
                            whiteSpace: "normal", // allows wrapping
                          },
                        }}
                        className="chip-btn"
                      />
                    </TableCell>
                    <TableCell className="table-cell">
                      <IconButton className="">
                        <Visibility
                          style={{color: "#0084ff"}}
                          onClick={() => gotodetail(item._id)}
                          className="icons"
                        />
                      </IconButton>
                               {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (

                      <IconButton className="">
                        <Edit
                          style={{ color: "#0084ff" }}
                          onClick={() => gotoEdit(item._id)}
                          className="icons"
                        />
                      </IconButton>)}
                               {getCurrentUser && getCurrentUser.role === 'admin' && getCurrentUser.role !== 'superAdmin' && (
 <IconButton
                        onClick={() => handleDeleteClick(item._id)}
                        className="icon-btn-red"
                        color="error"
                      >
                        <Delete className="icons " />
                      </IconButton>)}
                    </TableCell>
                  </TableRow>
                ))}
                <ConfirmDialog
                  open={openDialog}
                  onClose={() => setOpenDialog(false)}
                  onConfirm={confirmDelete}
                />
                {filteredData.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No Vehicle Found.
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
            </TableBody>
          </Table>
        </TableContainer>
        </div>
        <nav style={{ flexShrink: 0 }}>
          <ul className="pagination justify-content-center">
            <li className={`page-item ${page === 1 && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setPage((p) => Math.max(p - 1, 1))}
              >
                Previous
              </button>
            </li>

            {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
              <li
                key={i + 1}
                className={`page-item ${page === i + 1 && "active"}`}
              >
                <button className="page-link" onClick={() => setPage(i + 1)}>
                  {i + 1}
                </button>
              </li>
            ))}

            {pageCount > 5 && (
              <>
                <li className="page-item disabled">
                  <span className="page-link">...</span>
                </li>
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => setPage(pageCount)}
                  >
                    {pageCount}
                  </button>
                </li>
              </>
            )}

            <li className={`page-item ${page === pageCount && "disabled"}`}>
              <button
                className="page-link"
                onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </Paper>
    </div>
  );
};

export default VehicleList;

